// Mock data para Raio-X Licitatório - Mascarenhas e Lemos Construções
// Site institucional focado em conversão via planos

export const heroData = {
  badge: "Mercado público: R$ 359 bilhões/ano",
  title: "Prepare Sua Construtora Para Vencer Licitações Públicas",
  subtitle: "Diagnóstico completo em 15 dias para identificar e corrigir pendências que impedem sua empresa de participar e vencer licitações.",
  stats: [
    { value: "359", suffix: "bi", label: "Mercado público/ano" },
    { value: "15", suffix: "dias", label: "Prazo de entrega" },
    { value: "27", suffix: "+", label: "Documentos analisados" }
  ]
};

export const personasData = [
  {
    id: 1,
    icon: "Star",
    title: "Empreendedor Iniciante",
    description: "Executa obras de qualidade no mercado privado e deseja diversificar acessando o mercado público.",
    highlight: "Precisa de orientação para iniciar no mundo das licitações"
  },
  {
    id: 2,
    icon: "Lightbulb",
    title: "Sucessor(a) Empresário(a)",
    description: "Está assumindo a gestão da empresa familiar e busca modernizar processos e expandir atuação.",
    highlight: "Quer posicionar a empresa no mercado de obras públicas"
  },
  {
    id: 3,
    icon: "Target",
    title: "Gestor Experiente",
    description: "Já participou de licitações, mas enfrenta dificuldades com habilitação e documentação.",
    highlight: "Busca aumentar a taxa de sucesso nas participações"
  }
];

export const problemsData = {
  title: "Desafios Comuns na Participação em Licitações",
  problems: [
    "Documentação incompleta ou desatualizada para habilitação",
    "Desconhecimento dos requisitos técnicos exigidos nos editais",
    "Acervo técnico-profissional insuficiente ou mal organizado",
    "Falta de planejamento estratégico para precificação competitiva",
    "Tempo investido em propostas sem retorno"
  ],
  costBox: {
    title: "O Valor da Preparação",
    items: [
      { label: "Oportunidade de contrato", value: "R$ 500 mil a R$ 5 milhões" },
      { label: "Tempo de preparação adequada", value: "Essencial" },
      { label: "Segurança na participação", value: "Fundamental" }
    ],
    conclusion: "Investimento em diagnóstico: R$ 3.500 a R$ 12.000"
  }
};

export const solutionData = {
  title: "O Diagnóstico Licitatório",
  subtitle: "Análise completa para preparar sua construtora para o mercado público",
  steps: [
    {
      number: "01",
      title: "Análise Documental",
      description: "Verificação de todos os documentos essenciais para habilitação em licitações"
    },
    {
      number: "02",
      title: "Diagnóstico Técnico",
      description: "Avaliação do acervo técnico-profissional e capacidade operacional"
    },
    {
      number: "03",
      title: "Análise Financeira",
      description: "Verificação de índices e demonstrativos exigidos nos editais"
    },
    {
      number: "04",
      title: "Plano de Ação",
      description: "Roteiro priorizado para regularização de pendências identificadas"
    }
  ],
  deliverables: [
    "Relatório detalhado com diagnóstico completo",
    "Lista de pendências organizadas por prioridade",
    "Plano de ação com prazos realistas",
    "Reunião de apresentação e orientação"
  ]
};

export const benefitsData = {
  title: "Benefícios do Diagnóstico",
  benefits: [
    {
      icon: "Shield",
      title: "Segurança na Participação",
      description: "Saiba exatamente o que regularizar antes de participar"
    },
    {
      icon: "Clock",
      title: "Otimização de Tempo",
      description: "Foque apenas em licitações compatíveis com seu perfil"
    },
    {
      icon: "FileCheck",
      title: "Documentação Organizada",
      description: "Tenha todos os documentos prontos e atualizados"
    },
    {
      icon: "Target",
      title: "Estratégia Clara",
      description: "Planejamento direcionado para suas metas de crescimento"
    }
  ]
};

export const plansData = {
  title: "Escolha o Plano Ideal Para Sua Construtora",
  subtitle: "Selecione o diagnóstico mais adequado ao momento da sua empresa",
  plans: [
    {
      id: "essencial",
      name: "Diagnóstico Essencial",
      tagline: "Para quem está começando",
      price: 3500,
      installments: 3,
      installmentValue: 1167,
      featured: false,
      forWho: "Construtoras que nunca participaram de licitações e precisam do diagnóstico inicial completo.",
      features: [
        "Análise documental completa (27 documentos)",
        "Diagnóstico de acervo técnico-profissional",
        "Análise econômico-financeira básica",
        "Relatório de 15-20 páginas",
        "Plano de ação priorizado (30-90 dias)",
        "1 reunião de apresentação (1h)"
      ],
      bonus: "Cadastro no SICAF incluído (valor: R$ 500)",
      delivery: "15 dias úteis"
    },
    {
      id: "profissional",
      name: "Diagnóstico Profissional",
      tagline: "Para empresas em crescimento",
      price: 6500,
      installments: 3,
      installmentValue: 2167,
      featured: true,
      badge: "Mais Completo",
      forWho: "Construtoras que já participaram de licitações e buscam aumentar a competitividade.",
      features: [
        "Tudo do Diagnóstico Essencial +",
        "Análise de viabilidade de editais (até 3)",
        "Estratégia de precificação competitiva",
        "Diagnóstico de capacidade operacional",
        "Relatório de 25-30 páginas",
        "Plano de ação detalhado (90-180 dias)",
        "2 reuniões de acompanhamento (1h cada)"
      ],
      bonus: "Template de proposta técnica (valor: R$ 800)",
      delivery: "20 dias úteis"
    },
    {
      id: "premium",
      name: "Diagnóstico Premium",
      tagline: "Acompanhamento estratégico",
      price: 12000,
      installments: 3,
      installmentValue: 4000,
      featured: false,
      forWho: "Construtoras que desejam acompanhamento contínuo e estratégia de longo prazo.",
      features: [
        "Tudo do Diagnóstico Profissional +",
        "Análise de até 12 editais (2/mês por 6 meses)",
        "Mentoria estratégica mensal (6 sessões)",
        "Planejamento de crescimento personalizado",
        "Relatório executivo de 40-50 páginas",
        "Plano de ação estratégico (6 meses)",
        "Suporte prioritário por 6 meses"
      ],
      bonus: "Kit com 12 templates essenciais (valor: R$ 2.000)",
      delivery: "25 dias úteis"
    }
  ]
};

export const faqData = {
  title: "Dúvidas Frequentes",
  questions: [
    {
      question: "Qual o prazo de entrega do diagnóstico?",
      answer: "O prazo varia de 15 a 25 dias úteis após o envio completo da documentação, dependendo do plano escolhido."
    },
    {
      question: "O diagnóstico inclui elaboração de propostas?",
      answer: "Não. O diagnóstico prepara sua empresa para licitar, identificando pendências e orientando regularizações. Oferecemos templates e orientação, mas a elaboração da proposta é responsabilidade da construtora."
    },
    {
      question: "E se eu não tiver toda a documentação?",
      answer: "Parte do diagnóstico é identificar documentos faltantes e orientar como obtê-los. Você receberá um plano de ação claro."
    },
    {
      question: "O serviço funciona para qualquer tipo de licitação?",
      answer: "Nosso foco são licitações de obras e serviços de engenharia. Se sua construtora atua nesse segmento, o diagnóstico é adequado."
    },
    {
      question: "Quais as formas de pagamento?",
      answer: "À vista (PIX ou boleto) ou parcelado em até 3x sem juros no cartão de crédito."
    }
  ]
};

export const contactData = {
  whatsapp: {
    number: "5521974308413",
    display: "(21) 97430-8413"
  },
  email: "suzzana.lemmos@gmail.com",
  getWhatsappUrl: (planName) => {
    const message = `Olá! Tenho interesse no ${planName}. Gostaria de mais informações sobre o diagnóstico.`;
    return `https://wa.me/5521974308413?text=${encodeURIComponent(message)}`;
  }
};

export const footerData = {
  brand: "Mascarenhas e Lemos",
  tagline: "Assessoria especializada em licitações para construtoras",
  copyright: `© ${new Date().getFullYear()} Mascarenhas e Lemos Construções. Todos os direitos reservados.`,
  logo: "/logo.png"
};
